import { ZOOM_TRANSCRIPT_STATUS } from "~/providers/constants/zoomTranscriptStatus";
import { ZoomTranscriptStatus } from "~/providers/utils/types/zoomMeetingTypes";

const sessionTranscriptStatusLabels: Record<ZoomTranscriptStatus, string> = {
  IN_PROGRESS: "Processing",
  COMPLETED: "Available",
  FAILED: "Unavailable",
};

export const getSessionTranscriptStatusLabel = (
  status?: ZoomTranscriptStatus | null,
) => {
  if (!status) return "-";
  return sessionTranscriptStatusLabels[status] ?? "-";
};

export const isSessionTranscriptAvailable = (
  status?: ZoomTranscriptStatus | null,
) => status === ZOOM_TRANSCRIPT_STATUS.completed;
